import React from 'react';
import { Container, Box, Divider } from '@mui/material';
import StyledBox, {
  StyledNavMenuItem,
} from 'views/rebranded-module/common/components/Logical/LayoutV2/UtilityNav/UtilityNav.style';
import PATHS from 'lib/navigation/paths';
import { useSelector } from 'react-redux';
import { useTranslation } from 'next-i18next';
import { RiBuilding2Line, RiArrowLeftRightFill } from 'react-icons/ri';

const UtilityNav = () => {
  const { t } = useTranslation();
  const { appState } = useSelector((state) => state.globalData);
  const showCompanyName = appState.settings?.show_current_company
    && appState.current_company
    && appState.current_company.name;
  const showRenalMangagment = appState.settings?.show_rental_management_link;
  const companyName = appState.current_company?.name;

  return (
    <StyledBox>
      <Container maxWidth="xxl">
        <Box className="UNContainer">
          {showRenalMangagment && (
            <StyledNavMenuItem
              item={{
                label: t('common_layout_v2:navigation.rental_management'),
                path: PATHS.agent(),
                icon: <RiArrowLeftRightFill />,
              }}
              preventAnimation
            />
          )}
          {showRenalMangagment && showCompanyName && (
            <Divider orientation="vertical" flexItem className="UNDivider" />
          )}

          {showCompanyName && (
            <StyledNavMenuItem
              className="UNCompanyBtn"
              item={{
                label: companyName,
                path: PATHS.locations(),
                icon: <RiBuilding2Line />,
              }}
              readOnly
              preventAnimation
            />
          )}
        </Box>
      </Container>
    </StyledBox>
  );
};

export { UtilityNav };
